import {Box, Typography} from "@mui/material";

const Error404 = () => {
    return (
        <Box
            sx={{
                height: "100vh",
                backgroundColor: "rgb(49,153,188)",
                backgroundImage:
                    "linear-gradient(266deg, rgba(49,153,188,0.8547794117647058) 0%, rgba(255,255,255,1) 50%, rgba(248,152,28,0.7931547619047619) 100%)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "100px",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "20px",
                }}
            >
                <Box
                    component="img"
                    src="/logo.png"
                    alt="پرتفویار"
                    sx={{
                        width: "200px",
                    }}
                />
                <Typography
                    sx={{fontSize: "80px", color: "#000", fontWeight: "bold"}}
                >
                    404
                </Typography>
                <Typography
                    sx={{fontSize: "40px", color: "#000", fontWeight: "bold"}}
                >
                    این صفحه یافت نشد
                </Typography>
                <a href="/" className="btn btn-blue">بازگشت به صفحه اصلی</a>
            </Box>
        </Box>
    );
};

export default Error404;
